import { TableCell } from '@/components/ui/table';

interface CarryFundNameCellProps {
  name: string;
  displayName: string | null;
}

export function CarryFundNameCell({
  name,
  displayName,
}: CarryFundNameCellProps) {
  return (
    <TableCell>
      <div className="font-medium">{name}</div>
      {displayName && (
        <div
          className="max-w-64 truncate text-xs text-muted-foreground"
          title={displayName}
        >
          {displayName}
        </div>
      )}
    </TableCell>
  );
}
